import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]*)/);
      
      if (!sessionIdMatch) {
        toast.error("Session invalide");
        navigate("/connexion");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.post(
          `${API}/customer/auth/google`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Track successful Google login
        try {
          let visitorId = localStorage.getItem("sakura_visitor_id");
          if (!visitorId) {
            visitorId = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem("sakura_visitor_id", visitorId);
          }
          const customer = response.data.customer;
          await axios.post(`${API}/track-visit`, { 
            page: "client_login", 
            visitor_id: visitorId,
            customer_id: customer?.id,
            customer_name: customer?.name,
            customer_email: customer?.email
          }, { withCredentials: true });
          console.log("Google login tracked successfully");
        } catch (trackError) {
          console.error("Track visit error:", trackError);
          // Silent fail
        }

        toast.success("Connexion réussie !");
        
        // Clear the hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/mon-compte", { state: { user: response.data.customer } });
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Erreur de connexion Google");
        navigate("/connexion");
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-pink-50 to-white">
      <div className="text-center">
        <div className="animate-spin w-12 h-12 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-slate-600">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
